import type { VoidFunctionComponent } from 'react';

import { icons } from '../../../generic/Icon';
import { useCanManageOIDCProvider } from '../../shared/permissions';
import SettingsTableRowActions from '../../shared/SettingsTableRowActions';
import type { OIDCProvider } from '../../../../../shared/model-typings';

type ActionMenuDropdownProps = {
  provider: OIDCProvider;
  onDeleteProvider: (providerId: number) => void;
  onViewProvider: (providerId: number) => void;
};

const ActionMenuDropdown: VoidFunctionComponent<ActionMenuDropdownProps> = ({
  provider,
  onDeleteProvider,
  onViewProvider,
}) => {
  const canManageThisOIDCProvider = useCanManageOIDCProvider(provider.scopeId);

  return (
    <SettingsTableRowActions>
      <SettingsTableRowActions.IconButton
        tooltipId={`view-oidc-provider-${provider.id}`}
        tooltip="View"
        icon={icons.eyeRegular}
        onClick={() => onViewProvider(provider.id)}
      />
      {canManageThisOIDCProvider && <SettingsTableRowActions.IconButton
        tooltipId={`delete-oidc-provider-${provider.id}`}
        tooltip="Delete"
        icon={icons.trashRegular}
        onClick={() => onDeleteProvider(provider.id)}
      />}
    </SettingsTableRowActions>
  );
};

export default ActionMenuDropdown;
